<template>
	<div class="findPwd-form-part">
    <el-form :model="findPwdForm" :rules="rules" ref="findPwdForm" class="findPwd-form">
			<el-form-item prop="password" label="新密码:" label-width="90px">
				<div class="findPwd-item">
					<el-input
						v-model="findPwdForm.password"
						placeholder="输入新密码（字母和数字组合密码，至少6位）"
						class="findPwd-input"
						:type="pwdShow ? 'text' : 'password'"
						:clearable="true"
						:minlength="6"
						:maxlength="20"
						@keyup.enter.native="onKeyupInput"
					></el-input>
					<i class="findPwd-icon" :class="pwdShow ? 'pwdShow' : 'pwdHidden'" @click="pwdShowHandle"></i>
				</div>
			</el-form-item>
			<el-form-item prop="confirmPwd" label="确认密码:" label-width="90px">
				<div class="findPwd-item">
					<el-input
						v-model="findPwdForm.confirmPwd"
						placeholder="输入确认密码"
						class="findPwd-input"
						:type="confirmPwdShow ? 'text' : 'password'"
						:clearable="true"
						:minlength="6"
						:maxlength="20"
						@keyup.enter.native="onKeyupInput"
					></el-input>
					<i class="findPwd-icon" :class="confirmPwdShow ? 'pwdShow' : 'pwdHidden'" @click="confirmPwdShowHandle"></i>
				</div>
			</el-form-item>
			<el-form-item>
				<div class="findPwd-item">
					<el-input
						v-model="verifyCode"
						placeholder="输入图形验证码"
						class="findPwd-input verify-input"
						:clearable="true"
					></el-input>
					<img style="height: 40px;" :src="authCodeImgUrl" @click="onimageClick">
				</div>
			</el-form-item>
			<el-form-item prop="verificationCode" label="验证码:" label-width="90px">
				<div class="findPwd-item">
					<el-input
						v-model="findPwdForm.verificationCode"
						placeholder="输入验证码"
						class="findPwd-input verify-input"
						:clearable="true"
					></el-input>
					<el-button type="primary" size="small" class="verify-time-button" @click="getVerificationCode" v-if="!verifyTimeShow">获取验证码</el-button>
					<el-button type="primary" size="small" class="verify-time-button" v-if="timeShow">{{verifyTime}}s</el-button>
					<el-button type="primary" size="small" class="verify-time-button" @click="getVerificationCode" v-if="recoverFlag">重新获取</el-button>
				</div>
			</el-form-item>
			<el-button type="primary" class="submit-button" :disabled="findPwdBool" @click="findPwd">确认修改</el-button>
		</el-form>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { inputAutoFocus } from '@/js/lib/form'
export default {
	name: 'editPwd',
	props: {
		editShow: Boolean
	},
	data () {
		return {
			verifyUuid: this.$fxUtils.getUUID(),
			verifyCode: '',
			pwdShow: false,
			confirmPwdShow: false,
			verifyTime: 60,
			verifyTimeShow: false,
			timeShow: false,
			recoverFlag: false,
			phoneReg: /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/,
			passwordReg: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-z]|[A-Z]|[0-9]){6,}$/,
			chinessReg: /^[\s\S]*[\u4E00-\u9FFF]+[\s\S]*$/,
			findPwdForm: {
				username: '',
				password: '',
				confirmPwd: '',
				verificationCode: ''
			},
			rules: {
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ required: true,
						validator: (rule, value, callback) => {
							if (!this.passwordReg.test(value)) {
								callback(new Error('密码格式不正确'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				confirmPwd: [
					{ required: true, message: '请确认密码', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							if (value === '') {
								callback(new Error('请再次输入密码'))
							} else if (value !== this.findPwdForm.password) {
								callback(new Error('两次密码输入不一致！'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				verificationCode: [
					{ required: true, message: '请输入验证码', trigger: 'blur' }
				]
			}
		}
	},
	created () {
		this.findPwdForm.username = document.cookie.split('ycg:')[1].slice(0, 11)
	},
	computed: {
		...mapState({
			platFormName: state => state.platFormStore.platFormName
		}),
		findPwdBool () {
			if (this.findPwdForm.password && this.findPwdForm.confirmPwd && this.findPwdForm.verificationCode) {
				return false
			} else {
				return true
			}
		},
		authCodeImgUrl () {
			return `${this.$fxBaseApi.urlNVA}/${this.verifyUuid}/getVerifyCode`
		}
	},
	methods: {
		onimageClick () {
			this.timestamp = this.$fxUtils.getTime()
			this.verifyUuid = this.$fxUtils.getUUID()
		},
		tipsHandle (content, type, duration) {
			this.$message({
				message: content,
				type: type
			})
		},
		pwdShowHandle () {
			this.pwdShow = !this.pwdShow
		},
		confirmPwdShowHandle () {
			this.confirmPwdShow = !this.confirmPwdShow
		},
		onKeyupInput () {
			inputAutoFocus.apply(this, [event, 'findPwdForm']).then(() => {
				console.log(123)
			})
		},
		exit () {
			window.sessionStorage.removeItem('organid')
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlNVA}/logout`
			}).then(res => {
				window.sessionStorage.removeItem('shiroSession')
				// document.cookie = 'username:' + ''
				this.$router.replace({
					path: `/login`
				})
			})
		},
		getVerificationCode () {
			this.verifyTime = 60
			if (this.verifyCode === '') {
				this.tipsHandle('请输入图形验证码', 'error')
				return false
			}
			if (this.findPwdForm.username) {
				let data = {
					uuid: this.verifyUuid,
					verifyCode: this.verifyCode
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlNVA}/updatePasswordMsm/${this.findPwdForm.username}`,
					data
				}).then(res => {
					if (res.result) {
						this.tipsHandle('验证码已发送，请查收', 'success')
						this.verifyTimeShow = true
						this.recoverFlag = false
						this.timeShow = true
						this.timer = setInterval(() => {
							if (this.verifyTime === 0) {
								this.timeShow = false
								this.recoverFlag = true
								clearInterval(this.timer)
							}
							this.verifyTime--
						}, 1000)
						console.log(this.timer)
					} else {
						this.tipsHandle('验证码发送失败，请重试', 'error')
						this.verifyTimeShow = true
						this.timeShow = false
						this.recoverFlag = true
					}
				})
			}
		},
		findPwd () {
			if (this.findPwdForm.password.length < 6) {
				this.tipsHandle('密码格式不正确', 'error')
				return false
			}
			if (!this.passwordReg.test(this.findPwdForm.password) || this.chinessReg.test(this.findPwdForm.password)) {
				this.tipsHandle('密码格式不正确', 'error')
				return false
			}
			if (this.findPwdForm.password !== this.findPwdForm.confirmPwd) {
				return false
			}
			var params = {
				tel: this.findPwdForm.username,
				password: this.findPwdForm.password,
				checkCode: this.findPwdForm.verificationCode
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlNVA}/updatepwd`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tipsHandle('修改成功，请登录', 'success')
					this.exit()
				} else {
					if (res.code === '1101') {
						this.tipsHandle('该手机号不存在，请注册', 'error')
					} else if (res.code === 1102) {
						this.tipsHandle(res.msg, 'error')
					} else {
						this.tipsHandle('密码修改失败，请稍后再试或联系服务商', 'error')
					}
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.findPwd-form-part {
	display flex
	flex-direction column
	align-items center
	padding-top 30px
	p {
		font-weight 700
		font-size 20px
		padding: 30px 0
	}
	.findPwd-form {
		width: 390px
		.el-form-item {
			margin-bottom: 30px
		}
		.findPwd-item {
			display flex
			flex-direction row
			align-items center
			// border-bottom: 1px solid #7e8388
			/deep/ .el-input__inner {
				&::placeholder {
					color: #9fa2a5
          font-size: 12px
				}
				&::-webkit-input-placeholder {
					color: #9fa2a5
          font-size: 12px
				}
			}
			.findPwd-input {
				width 290px
			}
			.verify-input {
				width 230px
			}
			.findPwd-icon {
				display inline-block
				width 25px
				height 25px
			}
			.verify-time-button {
				width: 92px
				margin-left: 10px
			}
			.pwdShow {
				background-image: url('~images/icon/pwd-show.png')
			}
			.pwdHidden {
				background-image: url('~images/icon/pwd-hidden.png')
			}
		}
		.submit-button {
			width: 390px
			margin 20px 0 10px
		}
    .toLogin {
      float: right
      text-decoration: underline
      cursor: pointer
    }
    .toLogin:hover {
      color: var(--fx-primary-color)
    }
	}
	/deep/.el-form-item__label {
		text-align: left
	}
}

</style>
<style lang="stylus">
.edit-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
.findPwd-item {
	/deep/ .el-input__inner {
		font-family: 'Microsoft Yahei'
		padding-right: 15px
	}
}
</style>
